import {
  ChannelTypeEnum,
  MailConversationDataType,
  WechatConversationDataType,
  WecomConversationDataType,
  WhatsAppConversationDataType,
} from "../../types";
import EventBus from "../event-bus";

const globalChannelMessageHook = new EventBus<{
  channelType: ChannelTypeEnum;
  conversation:
    | WechatConversationDataType
    | WecomConversationDataType
    | MailConversationDataType
    | WhatsAppConversationDataType;
}>("globalChannelMessageHook");

export default globalChannelMessageHook;
